import { defineStore } from 'pinia'
import api from '@/services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('yapp_token'),
    isAuthenticated: false,
    initialized: false,
    loading: false,
    error: null
  }),

  getters: {
    currentUser: (state) => state.user,
    userPermissions: (state) => state.user?.permissions || {},
    userRole: (state) => state.user?.role || null,
    assignedClinics: (state) => state.user?.clinics || null,
    hasAllClinicsAccess: (state) => state.user?.clinics === null || (state.user?.permissions?.all_clinics === true)
  },

  actions: {
    async initializeAuth() {
      if (this.initialized) return

      if (this.token) {
        const savedUserData = localStorage.getItem('yapp_user_data')
        if (savedUserData) {
          try {
            this.user = JSON.parse(savedUserData)
            this.isAuthenticated = true
          } catch (error) {
            console.error('Error parsing saved user data:', error)
            this.clearAuth()
          }
        } else {
          this.clearAuth()
        }
      }

      this.initialized = true
    },

    async login(credentials) {
      this.loading = true
      this.error = null

      try {
        const response = await api.post('/api/auth/login', {
          username: credentials.username,
          password: credentials.password
        })

        if (response.data && response.data.success) {
          if (response.data.data && response.data.data.user && response.data.data.session) {
            const { user, session } = response.data.data

            this.token = session.id
            this.user = user
            this.isAuthenticated = true

            localStorage.setItem('yapp_token', session.id)
            localStorage.setItem('yapp_user_data', JSON.stringify(user))

            return { success: true }
          } else {
            throw new Error('Estructura de respuesta inválida')
          }
        } else {
          throw new Error(response.data?.error || 'Login failed')
        }
      } catch (error) {
        const errorMessage = error.response?.data?.error || error.message || 'Error de conexión'
        this.error = errorMessage
        return { success: false, error: errorMessage }
      } finally {
        this.loading = false
      }
    },

    async logout() {
      this.loading = true
      try {
        if (this.token) {
          try {
            await api.post('/api/auth/logout', { session_id: this.token })
          } catch (error) {
            // Ignore logout errors
          }
        }
      } finally {
        this.clearAuth()
        this.loading = false
      }
      return Promise.resolve()
    },

    clearAuth() {
      this.user = null
      this.token = null
      this.isAuthenticated = false
      this.error = null
      localStorage.removeItem('yapp_token')
      localStorage.removeItem('yapp_user_data')
    },

    hasPermission(permission) {
      if (!this.user || !this.user.permissions) return false
      return this.user.permissions[permission] === true
    }
  }
})
